// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-trangchu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.thongke-giayphep {
  display: flex;
  justify-content: center;
}

.thongke-giayphep-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.thongke-main {
  width: 100%;
  background-color: #fefeff;
  box-shadow: 0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025), 0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296), 0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);
  border-radius: 8px;
  padding: 10px;
}

.thongke-main-bieudo {
  padding: 25px !important;
}

.thongke-main-gp {
  width: 100%;
  background-color: #fefeff;
  box-shadow: 0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025), 0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296), 0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);
  border-radius: 8px;
  padding: 25px;
  height: 100%;
  min-height: 350px;
}

.thongke-icon {
  width: 56px;
  height: 56px;
  background-color: #1ba355;
  border-radius: 50%;
  padding-top: 10px;
  text-align: center;
  margin-right: 10px;
  margin-left: 10px;
}

.thongke-component {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 5px;
}
.thongke-component:hover {
  background-color: #ccdbc5;
}

.thongke-component-gp {
  display: flex;
  justify-content: space-between;
  margin-left: 17px;
  margin-right: 17px;
  margin-top: 8px;
}

.thongke-number {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #333333;
  margin-top: 8px;
  cursor: pointer;
}

.thongke-title1 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #777777;
}

.thongke-title {
  font-style: normal;
  font-weight: 540;
  font-size: 16px;
  line-height: 19px;
  color: #777777;
  padding-left: 20px;
  display: flex;
  align-items: center;
}

.thongke-contaier-hieuluc {
  display: flex;
  align-items: center;
}

.thongke-title-hieuluc {
  font-style: normal;
  font-weight: 550;
  font-size: 16px;
  line-height: 19px;
  color: #333333;
}

.bieudocot-label {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 17px;
  color: #000000;
}

.bieudocot-legend-label {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.bieudocot-nam {
  margin-right: 5px;
  margin-top: 3px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}

.bieudotron-chuthich {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}

.bieudotron-chuthich-solieu {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  margin-left: 15px;
  color: #000000;
}

.bieudotron {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 50px;
  padding-bottom: 50px;
}

.thongke-item {
  border-radius: 5px;
}

.thongke-item:hover {
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

.thongkehieuluc {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  line-height: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
}

.thongke-component-gp-hieuluc {
  display: flex;
  margin-bottom: 7px;
}

.thongke-title-dtm {
  font-style: normal;
  font-weight: 540;
  font-size: 16px;
  line-height: 19px;
  color: #777777;
}

.thongke-number-dtm {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  /* margin-top: 8px; */
  cursor: pointer;
  margin-bottom: 10px;
}

.thongke-number-gp {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  /* margin-top: 8px; */
  cursor: pointer;
  text-align: left;
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/styles/trangchu.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AACA;EACI,aAAA;EAEA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,uKACI;EAGJ,kBAAA;EACA,aAAA;AAFJ;;AAIA;EACI,wBAAA;AADJ;;AAGA;EACI,WAAA;EACA,yBAAA;EACA,uKACI;EAGJ,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;AAII;EACI,yBAAA;AAFR;;AAMA;EACI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAHJ;;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFJ;;AAIA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AADJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AACA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAGJ;;AADA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;AAIJ;;AAFA;EACI,kBAAA;AAKJ;;AAHA;EACI,yHACI;AAKR;;AADA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAIJ;;AAFA;EACI,aAAA;EACA,kBAAA;AAKJ;;AAHA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAMJ;;AAJA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAOJ;;AALA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAQJ","sourcesContent":[".body-trangchu {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: 20px;\r\n}\r\n.thongke-giayphep {\r\n    display: flex;\r\n    // flex-direction: column;\r\n    justify-content: center;\r\n    // gap: 10px;\r\n}\r\n.thongke-giayphep-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 20px;\r\n}\r\n\r\n.thongke-main {\r\n    width: 100%;\r\n    background-color: #fefeff;\r\n    box-shadow:\r\n        0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025),\r\n        0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296),\r\n        0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);\r\n    border-radius: 8px;\r\n    padding: 10px;\r\n}\r\n.thongke-main-bieudo {\r\n    padding: 25px !important\r\n}\r\n.thongke-main-gp {\r\n    width: 100%;\r\n    background-color: #fefeff;\r\n    box-shadow:\r\n        0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025),\r\n        0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296),\r\n        0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);\r\n    border-radius: 8px;\r\n    padding: 25px;\r\n    height: 100%;\r\n    min-height: 350px;\r\n}\r\n\r\n.thongke-icon {\r\n    width: 56px;\r\n    height: 56px;\r\n    background-color: #1ba355;\r\n    border-radius: 50%;\r\n    padding-top: 10px;\r\n    text-align: center;\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.thongke-component {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    border-radius: 5px;\r\n    &:hover {\r\n        background-color: #ccdbc5;\r\n    }\r\n    // justify-content: space-around;\r\n}\r\n.thongke-component-gp {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-left: 17px;\r\n    margin-right: 17px;\r\n    margin-top: 8px;\r\n}\r\n.thongke-number {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    line-height: 22px;\r\n    color: #333333;\r\n    margin-top: 8px;\r\n    cursor: pointer;\r\n}\r\n\r\n.thongke-title1 {\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    color: #777777;\r\n}\r\n.thongke-title {\r\n    font-style: normal;\r\n    font-weight: 540;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    color: #777777;\r\n    padding-left: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.thongke-contaier-hieuluc{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.thongke-title-hieuluc {\r\n    font-style: normal;\r\n    font-weight: 550;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    color: #333333;\r\n}\r\n\r\n.bieudocot-label {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n    line-height: 17px;\r\n    color: #000000;\r\n}\r\n\r\n.bieudocot-legend-label {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 15px;\r\n    color: #000000;\r\n}\r\n\r\n.bieudocot-nam {\r\n    margin-right: 5px;\r\n    margin-top: 3px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    color: #000000;\r\n}\r\n.bieudotron-chuthich {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    color: #000000;\r\n}\r\n.bieudotron-chuthich-solieu {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    margin-left: 15px;\r\n    color: #000000;\r\n}\r\n.bieudotron {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    padding-top: 50px;\r\n    padding-bottom: 50px;\r\n}\r\n.thongke-item{\r\n    border-radius: 5px;\r\n}\r\n.thongke-item:hover {\r\n    box-shadow:\r\n        0px 1px 3px 0px rgba(0, 0, 0, 0.12),\r\n        0px 1px 3px 0px rgba(0, 0, 0, 0.12),\r\n        0px 1px 3px 0px rgba(0, 0, 0, 0.12);\r\n}\r\n.thongkehieuluc {\r\n    color: rgb(255 255 255);\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    line-height: 30px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n}\r\n.thongke-component-gp-hieuluc {\r\n    display: flex;\r\n    margin-bottom: 7px;\r\n}\r\n.thongke-title-dtm {\r\n    font-style: normal;\r\n    font-weight: 540;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    color: #777777;\r\n}\r\n.thongke-number-dtm {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    line-height: 22px;\r\n    color: #333333;\r\n    /* margin-top: 8px; */\r\n    cursor: pointer;\r\n    margin-bottom: 10px;\r\n}\r\n.thongke-number-gp {\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    line-height: 22px;\r\n    color: #333333;\r\n    /* margin-top: 8px; */\r\n    cursor: pointer;\r\n    text-align: left;\r\n    margin-left: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
